import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enBlog from "./en/blog.json";
import enCommon from "./en/common.json";
import enContact from "./en/contact.json";
import enEvents from "./en/events.json";
import enFooter from "./en/footer.json";
import enHome from "./en/home.json";
import enNavigation from "./en/navigation.json";
import enProjects from "./en/projects.json";
import enPublications from "./en/publications.json";
import enTeam from "./en/team.json";

import zhBlog from "./zh-cn/blog.json";
import zhCommon from "./zh-cn/common.json";
import zhContact from "./zh-cn/contact.json";
import zhEvents from "./zh-cn/events.json";
import zhFooter from "./zh-cn/footer.json";
import zhHome from "./zh-cn/home.json";
import zhNavigation from "./zh-cn/navigation.json";
import zhProjects from "./zh-cn/projects.json";
import zhPublications from "./zh-cn/publications.json";
import zhTeam from "./zh-cn/team.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: {
      en: ["en"],
      "zh-CN": ["zh_Hans"],
      "zh-TW": ["zh_Hant"],
      default: ["en"],
    },
    debug: false,
    lng: "en",
    supportedLngs: ["en", "zh_Hans"],

    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        blog: enBlog,
        common: enCommon,
        contact: enContact,
        events: enEvents,
        footer: enFooter,
        home: enHome,
        navigation: enNavigation,
        projects: enProjects,
        publications: enPublications,
        team: enTeam,
      },
      zh_Hans: {
        blog: zhBlog,
        common: zhCommon,
        contact: zhContact,
        events: zhEvents,
        footer: zhFooter,
        home: zhHome,
        navigation: zhNavigation,
        projects: zhProjects,
        publications: zhPublications,
        team: zhTeam,
      },
    },
    ns: [
      "translations",
      "footer",
      "home",
      "navigation",
      "team",
      "blog",
      "common",
      "contact",
      "events",
      "projects",
      "publications",
    ],
    defaultNS: "translations",
  });

export default i18n;
